import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { branch, renderComponent, compose } from 'recompose'
import injectSagas from 'helpers/injectSagas'

import RejectDialog from './RejectDialog'
import AcceptDialog from './AcceptDialog'

import {
  MODULE_NAME,
  APPROVAL_TYPE
} from './constants'

import {
  setDialogInactive,
  updateType,
  updateComment,
  submit,
} from './actions'

import {
  commentSelector,
  activeSelector,
  typeSelector,
  dialogTypeSelector,
  skipablesSelector
} from './selectors'

import sagas from './sagas'

const mapStateToProps = (state) => {
  return {
    active: activeSelector(state),
    comment: commentSelector(state),
    dialogType: dialogTypeSelector(state),
    type: typeSelector(state),
    skipables: skipablesSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateType: (value) => dispatch(updateType(value)),
    onUpdateComment: (value) => dispatch(updateComment(value)),
    disableDialog: () => dispatch(setDialogInactive()),
    onSubmit: () => dispatch(submit()),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({ [MODULE_NAME]: sagas })

const ApprovalDialog = branch(
  ({ dialogType }) => dialogType === APPROVAL_TYPE.APPROVE,
  renderComponent(AcceptDialog)
)(RejectDialog)

export default compose(
  withSagas,
  withConnect,
)(ApprovalDialog)
